import React from "react";
import "./Home.css";
import Lottie from "react-lottie";
import animationData from "./Hero-Animation.json";
import {Link} from "react-router-dom";
import ReactTextTransition from "react-text-transition";

const Home = () => {
	
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
	};

	return (
		<div className="home-container">
			<div className="home-content">
				<div className="hero-text">
					<h1 className="hero-title">
						{"Learn Your Way (LurW)".split("").map((txt, i) => (
							<ReactTextTransition key={i} direction="down" inline>
								{txt === " " ? "\u00A0" : txt}
							</ReactTextTransition>
						))}
					</h1>

					<div className="desc">
						{"Meet the AI that customizes your course content based on your learning level.It's like having a personal tutor who tailors the lessons just for you!"
							.split("")
							.map((txt, i) => (
								<ReactTextTransition key={i} delay={i * 30} inline>
									{txt === " " ? "\u00A0" : txt}
								</ReactTextTransition>
							))}
						<div className="loginbtn">
							<Link to="/login">Get Started</Link>
						</div>
					</div>
				</div>
				<div className="hero-img">
					<Lottie options={defaultOptions} />
				</div>
			</div>
		</div>
	);
}

export default Home;
